import src from "IMAGE";
export default { src, width: 51, height: 123, blurWidth: 3, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAAOklEQVR42k3MOQoAIBBD0bQqKCq44v2vaYQJWLziMwsAZBrkCPWPRJuCJlNR6CiirfUX3taabtb7dgFV8QG8ekdSqQAAAABJRU5ErkJggg=="};
